import { Button } from "common/components/Button";
import { DropdownOption } from "common/components/DropdownMenu";
import React, { MouseEvent as ReactMouseEvent } from "react";

interface OptionButtonProps {
  index: number;
  option: DropdownOption;
  onClick?: (e: ReactMouseEvent<HTMLElement>, option: DropdownOption) => void;
}

export const OptionButton: React.FC<OptionButtonProps> = ({ index, option, onClick }) => {
  const invalidAnalyticsData = React.isValidElement(option.label);
  return (
    <Button
      key={index}
      variant="tertiary"
      size="md"
      data-test={`dropdown-option-${index}`}
      block
      className={`!justify-start${index !== 0 ? " mt-xs" : ""}${option.active ? " bg-gray-50" : ""}`}
      leadingIcon={option.leadingIcon}
      analyticsAction="click dropdown menu option"
      {...(!invalidAnalyticsData && { analyticsData: { label: option.label } as any })}
      onClick={onClick ? (e) => onClick(e, option) : () => {}}>
      {option.label}
    </Button>
  );
};
